import AppConfig from '../../utils/appconfig';
import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';
import { useEffect } from 'react';
import { SectionTitle } from '../../components/sectionTitle';
import { scrollBodyToTop } from '../../utils/utils';
import { LinkButton } from '../../components/linkButton';
import ImageGallery from "react-image-gallery";

import galleryImg1 from '../../images/gallery/hard-gallery-11.webp';
import galleryImg2 from '../../images/gallery/hard-gallery-12.webp';
import galleryImg3 from '../../images/gallery/hard-gallery-13.webp';
import galleryImg4 from '../../images/gallery/hard-gallery-14.webp';
import galleryImg5 from '../../images/gallery/hard-gallery-15.webp';
import galleryImg6 from '../../images/gallery/hard-gallery-16.webp';
import galleryImg7 from '../../images/gallery/hard-gallery-17.webp';
import galleryImg8 from '../../images/gallery/hard-gallery-18.webp';
import galleryImg9 from '../../images/gallery/hard-gallery-19.webp';
import galleryImg10 from '../../images/gallery/hard-gallery-20.webp';


const images = [
  { original: galleryImg1 },
  { original: galleryImg2 },
  { original: galleryImg3 },
  { original: galleryImg4 },
  { original: galleryImg5 },
  { original: galleryImg6 },
  { original: galleryImg7 },
  { original: galleryImg8 },
  { original: galleryImg9 },
  { original: galleryImg10 },
];

const currentPage: string = 'galeria';

export function Galeria() {
  useEffect(() => {
    document.title = `Galeria - ${AppConfig.baseTabTitle}`;

    scrollBodyToTop();
  }, []);

  return (
    <div className="App theme-light">
      <Navbar currentPage={currentPage} />

      <div className="content-wrapper galeria__content-wrapper">
        <div className="galeria__text">

          <SectionTitle title={<>Hard Adv <span className="text-color--primary">Galeria</span></>} customClassName={'section-title__wrapper--home'} />
          <p>Archiwum z naszych wypraw jest na platformie <span className="text-weight--superBold">Dysk Google</span>:</p>
          <div className="galeria__buttons-wrapper">
            <LinkButton buttonText={'Grecja 2025 1'} linkTo={'https://drive.google.com/drive/folders/1e1px51p_QgFEdvARZ6DD85AZg7HjGDPk?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
            <LinkButton buttonText={'Grecja 2025 2'} linkTo={'https://drive.google.com/drive/folders/18aiVgFmFxa5R6y6zQlXtQeWX_pFdfPrB?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
            <LinkButton buttonText={'Grecja 2026'} linkTo={'https://drive.google.com/drive/folders/1eic_vDrsZwCgK-otrqR4KkOi_Y3T0nYa?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
          </div>
          <div className="galeria__buttons-wrapper">
            <LinkButton buttonText={'Gruzja 2026 1'} linkTo={'https://drive.google.com/drive/folders/1XGDs9sPIuNGptG9FseNUdTPu-LHSXykO?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
            <LinkButton buttonText={'Gruzja 2026 2'} linkTo={'https://drive.google.com/drive/folders/1pbB9WLgRcvdOZH7WpyxC2q5sG4nmYWnM?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
          </div>
          <div className="galeria__buttons-wrapper">
            <LinkButton buttonText={'Polska 2024'} linkTo={'https://drive.google.com/drive/folders/1ra0NbjJv8Q9-LcUcIEdXhbfwu5537oF1?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
            <LinkButton buttonText={'Polska 2025'} linkTo={'https://drive.google.com/drive/folders/13ZfknI39LwLvOrbJ5uu2u0QRGbuuxAYX?usp=drive_link'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
            <LinkButton buttonText={'Polska 2026'} linkTo={'https://drive.google.com/drive/folders/1d4_A4Zyl01cithunPxRMsJyMqOSBAS6d?usp=sharing'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
          </div>
        </div>
      </div>
          <p>Filmy z naszych wypraw jest na platformie <span className="text-weight--superBold">Youtube</span>:</p>
    <div className="galeria__buttons-wrapper">
      <LinkButton buttonText={'Wideo z wypraw'} linkTo={'https://youtube.com/playlist?list=PLMhZjG7QvZ5B9ZpzMv8QumPhZYifVC_F1&si=Bri0x9m663h8j4XB'} target={'_blank'} customClassName="home-section-1__button-link-wrapper galeria__action-button" />
    </div>
      <div style={{marginBottom: '50px'}}>
        <ImageGallery items={images} showThumbnails={false} showBullets={true} lazyLoad={true} autoPlay={true} />
      </div>

      <Footer currentPage={currentPage} />
    </div>
  );
}
